/**
 * Common types for the Blockdaemon SDK common module.
 *
 * @remarks
 * This module contains comprehensive type definitions for common blockchain operations
 * including balance queries, token information, pricing data, and module configuration.
 * These types provide full type safety and detailed documentation for all SDK operations.
 *
 * @packageDocumentation
 */
/**
 * Standardized asset type enumeration.
 *
 * @remarks
 * Defines the four standardized asset types used across the SDK for consistent
 * token classification across different blockchain networks.
 *
 * **Asset Types:**
 * - `FUNGIBLE_TOKEN` - Standard fungible tokens (SPL, etc.)
 * - `NON_FUNGIBLE_TOKEN` - Non-fungible tokens (SPL NFTs, etc.)
 * - `ERC20` - Ethereum ERC-20 tokens
 * - `ERC1155` - Ethereum ERC-1155 tokens
 *
 * @example
 * ```typescript
 * const tokenType: AssetType = AssetType.ERC20;
 * console.log(tokenType); // "ERC20"
 * ```
 *
 * @public
 */
export var AssetType;
(function (AssetType) {
    /** Standard fungible tokens (ERC-20, SPL, etc.) */
    AssetType["FUNGIBLE_TOKEN"] = "Fungible Token";
    /** Non-fungible tokens (ERC-721, SPL NFTs, etc.) */
    AssetType["NON_FUNGIBLE_TOKEN"] = "Non-Fungible Token";
    /** Ethereum ERC-20 tokens */
    AssetType["ERC20"] = "ERC20";
    /** Ethereum ERC-1155 tokens */
    AssetType["ERC1155"] = "ERC1155";
})(AssetType || (AssetType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbWFpbi9tb2R1bGVzL2NvbW1vbi90eXBlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7O0dBU0c7QUFPSDs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7R0FvQkc7QUFDSCxNQUFNLENBQU4sSUFBWSxTQVNYO0FBVEQsV0FBWSxTQUFTO0lBQ25CLG1EQUFtRDtJQUNuRCw4Q0FBaUMsQ0FBQTtJQUNqQyxvREFBb0Q7SUFDcEQsc0RBQXlDLENBQUE7SUFDekMsNkJBQTZCO0lBQzdCLDRCQUFlLENBQUE7SUFDZiwrQkFBK0I7SUFDL0IsZ0NBQW1CLENBQUE7QUFDckIsQ0FBQyxFQVRXLFNBQVMsS0FBVCxTQUFTLFFBU3BCIn0=